export default __webpack_public_path__ + "6a6aba21e1847620e57ea7b727b2107b.png";